import React, { Component, Suspense, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { withMsal, useIsAuthenticated } from "@azure/msal-react";
import SimpleLoading from "./components/simple_loading/SimpleLoading";
import PrivateRoute from "./components/route/PrivateRoute";
import { HttpService, refreshTokenTimer, getAzurePhoto } from "./utilities";
import { doLogout as doLogoutHelper } from "./utilities/Helper";
import { bindReturnUrl } from "./utilities/Helper";
import { ApiService } from "./constants";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MsalContext } from "@azure/msal-react";
import { setAuthUser, setAuthFetch, showModal } from "../src/actions/auth";
import { fetchLandingConfig } from "../src/actions/config";
import { refreshAuthToken, startInterval, runningInterval, stopInterval } from "../src/actions/refresh_token";
import "./scss/App.scss";
import 'react-quill/dist/quill.snow.css'
import Swal from "sweetalert2";
import SplashScreen from "./components/splashscreen";
import {Debugger} from "inspector";

declare interface IAppProps {
  authUser?: any;
  setAuthUser?: any;
  showModal?: any;
  setAuthFetch?: any;
  fetchLandingConfig?: any;
  startInterval?: any;
  runningInterval?: any;
  stopInterval?: any;
  refreshAuthToken?: any;
  msalContext?: any;
  auth?: any;
  refreshToken?: any;
  config?: any;
}

declare global {
  interface Window {
    jQuery: any;
  }
}

//main pages
const Home = React.lazy(() => import("./views/home"));
const Page = React.lazy(() => import("./views/page"));
const Logout = React.lazy(() => import("./views/logout/Logout"));

//admin pages
const Homepage = React.lazy(() => import("./views/homepage"));
const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const SelfReport = React.lazy(() => import("./views/self_report"));
const SelfReportDetail = React.lazy(() => import("./views/self_report/detail"));
const BcldReview = React.lazy(() => import("./views/self_report/bcld_review"));
const Event = React.lazy(() => import("./views/event/event"));
const EventDetail = React.lazy(() => import("./views/event/event/Detail"));
const Events = React.lazy(() => import("./views/events/event/Event"));
const EventsForm = React.lazy(() => import("./views/events/event/EventForm"));

const Role = React.lazy(() => import("./views/role_management"));
const RoleForm = React.lazy(() => import("./views/role_management/roles/RoleForm"));

const Leader = React.lazy(() => import("./views/leader_wisdom/leaders/Leader"));
const LeaderForm = React.lazy(() => import("./views/leader_wisdom/leaders/LeaderForm"));

const Personal = React.lazy(() => import("./views/personal_wisdom/personal/Personal"));
const PersonalForm = React.lazy(() => import("./views/personal_wisdom/personal/PersonalForm"));
const MyPersonal = React.lazy(() => import("./views/my_personal_wisdom"));

const Testimony = React.lazy(() => import("./views/testimony/testimony/Testimony"));
const TestimonyForm = React.lazy(() => import("./views/testimony/testimony/TestimonyForm"));
const MyTestimony = React.lazy(() => import("./views/my_testimony"));

const Content = React.lazy(() => import("./views/content/content/Content"));
const ContentForm = React.lazy(() => import("./views/content/content/ContentForm"));
const ContentView = React.lazy(() => import("./views/content/content/ContentView"));

const LandingForm = React.lazy(() => import("./views/landing_page/landing/LandingForm"));
const HomepageManagement = React.lazy(() => import("./views/homepage_management/homepage/HomepageForm"));
const FooterManagement = React.lazy(() => import("./views/footer_management/footer/FooterForm"));

const TrainingCertificates = React.lazy(() => import("./views/training_certificates"));
const DocumentViewer = React.lazy(() => import("./views/document_viewer"));

declare interface IAppState { azurePhoto: string, loadingDelay?: Boolean }

class App extends Component<IAppProps, IAppState> {
  constructor(props: Readonly<IAppProps>) {
    super(props);
    this.state = {
      azurePhoto: '',
      loadingDelay: false
    }
  }

  static contextType = MsalContext;
  context!: React.ContextType<typeof MsalContext>;

  async componentDidMount(): Promise<any> {
    //hanlde if set auth user error or reload browser manual by user
    this.props.setAuthFetch(false);

    this.props.fetchLandingConfig();
    this.handleAzureLogin(this);

    const redirect_after_login = window.localStorage.getItem('redirect_after_login');
    if (redirect_after_login) {
      this.setState({ loadingDelay: true });
    }

    setTimeout(() => {
      window.localStorage.removeItem('redirect_after_login');
      this.setState({ loadingDelay: false });
    }, 2000);
  }

  handleAzureLogin = (SELF) => {
    SELF.context.instance.handleRedirectPromise().then(res => {
      if (res) { // if login azure
        this.props.setAuthFetch(true);
        getAzurePhoto(SELF.context.instance, res.account, (base64DataUri) => {
          SELF._setAuthUserWithAzure(SELF, res, base64DataUri);
        }, (err) => {
          SELF._setAuthUserWithAzure(SELF, res, '');
        });
      } else { // if not login azure
        if (!SELF.props.auth) { // if not login manual
          const return_url = window.localStorage.getItem("return_url");
          if (return_url) {
            SELF.props.showModal(true);
          }
        }
      }
    });
  }

  _setAuthUserWithAzure = (SELF, res, azurePhoto) => {
    SELF.props.setAuthUser(res.account.username, null, azurePhoto).then(result => {
      if (result && result.userName) {
        setTimeout(() => { bindReturnUrl(); }, 100);
      } else {
        Swal.fire({
          html: `Login failed,<br />please use your employee/lecturer email`,
          icon: 'warning'
        }).then((result) => {
          doLogoutHelper(true, SELF.context.instance, false)
        });
      }
    });
  }

  renderRouteNew = () => {
    return (
      <Suspense fallback={<SplashScreen />}>
        <Switch>
          <Route
            exact
            path='/'
            render={props => <Home />}
          />
          <Route
            exact
            path='/page/:id'
            render={props => <Page {...props} />}
          />
          <Route
            exact
            path='/logout'
            render={props => <Logout />}
          />
          <PrivateRoute
            exact
            path='/home'
            render={props => <Homepage {...this.props} />}
          />
          <PrivateRoute
            exact
            path='/dashboard/main'
            render={props => <Dashboard />}
          />

          <PrivateRoute
            exact
            path='/dashboard/self-report'
            render={props => <SelfReport {...props} />}
          />
          <PrivateRoute
            exact
            path='/dashboard/self-report/:id'
            render={props => <SelfReport {...props} />}
          />
          <PrivateRoute
            exact
            path='/dashboard/self-report/review/:id/:type'
            render={props => <SelfReportDetail {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/bcld-review'
            render={props => <BcldReview />}
          />
          <PrivateRoute
            exact
            path='/management/bcld-review/:id/:type'
            render={props => <SelfReportDetail {...props} />}
          />
          <PrivateRoute
            exact
            path='/dashboard/personal-wisdom'
            render={props => <MyPersonal azurePhoto={this.props.auth.azurePhoto} />}
          />

          <PrivateRoute
            exact
            path='/dashboard/testimony'
            render={props => <MyTestimony {...props} azurePhoto={this.props.auth.azurePhoto} />}
          />

          <PrivateRoute
            exact
            path='/event'
            render={props => <Event {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path='/event/:id'
            render={props => <EventDetail {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path='/management/events'
            render={props => <Events {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/events/:id'
            render={props => <EventsForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/role'
            render={props => <Role />}
          />
          <PrivateRoute
            exact
            path='/management/role/form'
            render={props => <RoleForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/role/form/:id'
            render={props => <RoleForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/leader-wisdom'
            render={props => <Leader {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/leader-wisdom/form'
            render={props => <LeaderForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/leader-wisdom/form/:id'
            render={props => <LeaderForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/personal-wisdom'
            render={props => <Personal {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/personal-wisdom/form'
            render={props => <PersonalForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/personal-wisdom/form/:id'
            render={props => <PersonalForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/testimony'
            render={props => <Testimony {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/testimony/form'
            render={props => <TestimonyForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/testimony/form/:id'
            render={props => <TestimonyForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/content'
            render={props => <Content {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/content/form'
            render={props => <ContentForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/content/form/:id'
            render={props => <ContentForm {...props} />}
          />
          <PrivateRoute
            exact
            path='/management/content/view/:id'
            render={props => <ContentView {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/landing-page'
            render={props => <LandingForm {...props} />}
          />

          <PrivateRoute
            exact
            path='/management/homepage-management'
            render={props => <HomepageManagement {...props} {...this.props} />}
          />

          <PrivateRoute
            exact
            path='/management/footer'
            render={props => <FooterManagement {...props} />}
          />

          <PrivateRoute
            exact
            path='/dashboard/certificates'
            render={props => <TrainingCertificates {...props} />}
          />

          <Route
            exact
            path='/doc-viewer'
            render={props => <DocumentViewer {...props} />}
          />
          {/* <PrivateRoute
            exact
            path='/dashboard/self-report/view-doc/:id/:type'
            render={props => <SelfReportDetail {...props} />}
          /> */}

          {/**
           Beelajar domain redirects
           If applicable, please use regex
           */}
          <Route
              exact
              path='/verify_certificate'
              render={() => {
                const beelajarBaseURL = new URL(ApiService.beelajar.postRequestLogin).origin
                const pathName = window.location.pathname
                const queryString = window.location.search
                window.location.href = `${beelajarBaseURL}${pathName}${queryString}`
                return null;
              }}
          />

          <Route
              path='/mod'
              render={() => {
                const beelajarBaseURL = new URL(ApiService.beelajar.postRequestLogin).origin
                const pathName = window.location.pathname
                const queryString = window.location.search
                window.location.href = `${beelajarBaseURL}${pathName}${queryString}`
                return null;
              }}
          />

          <Route
              path='/course'
              render={() => {
                const beelajarBaseURL = new URL(ApiService.beelajar.postRequestLogin).origin
                const pathName = window.location.pathname
                const queryString = window.location.search
                window.location.href = `${beelajarBaseURL}${pathName}${queryString}`
                return null;
              }}
          />

        </Switch>
      </Suspense>
    )
  }

  render() {
    if (this.props.auth) {
      if (!this.props.refreshToken.isRunning) {
        this.props.startInterval();
        refreshTokenTimer(this.props.refreshAuthToken, this.props.runningInterval, this.props.stopInterval);
      }
    }

    return (this.state.loadingDelay) ? <SplashScreen /> : this.renderRouteNew();
  }
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData,
    config: state.config,
    refreshToken: state.refreshToken,
  }
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({
    setAuthUser,
    showModal,
    setAuthFetch,
    fetchLandingConfig,
    refreshAuthToken,
    startInterval,
    runningInterval,
    stopInterval
  }, dispatch);
}

export default withMsal(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));
